(function () {
  const cards = document.querySelectorAll('.card-wrapper[data-product-handle]');
  if (!cards.length) return;

  const soldOutColor = cards[0].dataset.soldOutColor || 'color-inverse';
  const saleColor = cards[0].dataset.saleColor || 'color-accent-2';

  const handles = [...new Set([...cards].map(c => c.dataset.productHandle))];

  handles.forEach(handle => {
    fetch('/products/' + handle + '.js')
      .then(r => r.json())
      .then(product => {
        document.querySelectorAll('.card-wrapper[data-product-handle="' + handle + '"] .card__badge').forEach(el => {
          el.innerHTML = '';
          if (!product.available) {
            el.innerHTML = '<span class="badge badge--bottom-left ' + soldOutColor + '">Sold out</span>';
          } else if (product.compare_at_price > product.price && product.price === 360000) {
            el.innerHTML = '<span class="badge badge--bottom-left ' + saleColor + '">Sale</span>';
          }
        });
      })
      .catch(() => {});
  });
})();
